import _defineProperty from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var _excluded = ["videoSrc", "videoType", "loop", "buttonTopAlignment", "buttonBottomLeftAlignment", "buttonTopLeftAlignment", "buttonTopRightAlignment", "click", "hoverVideoPlay", "carouselEvent", "structuredScript", "structuredScriptData", "buttonCenterAlignment", "autoplay", "muted", "buttonFilled", "videoFullHeight", "isDetSite"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import './Video.css';
import React, { useState, useCallback, useMemo } from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { canUseDOM, getGlobalDictionaryTerm } from '../../../utils';
import IconPauseItem from '../../../components/atoms/Icons/IconPause2';
import IconPlayItem from '../../../components/atoms/Icons/IconPlay';
import IconPlay2Item from '../../../components/atoms/Icons/IconPlay2';
import IconPlayDDA from '../../../components/atoms/Icons/IconDDAPlay';
import IconPauseDDA from '../../../components/atoms/Icons/IconDDAPause';
import { useVideoStructuredData } from './useVideoStructuredData';
import { useInView } from 'react-intersection-observer';
import clsx from 'clsx';
import throttle from 'lodash/throttle';
var videoWhiteOverlayTime = 750;
var videoFadeTime = 400;
var Video = function Video(_ref) {
  var videoSrc = _ref.videoSrc,
    _ref$videoType = _ref.videoType,
    videoType = _ref$videoType === void 0 ? '' : _ref$videoType,
    _ref$loop = _ref.loop,
    loop = _ref$loop === void 0 ? true : _ref$loop,
    _ref$buttonTopAlignme = _ref.buttonTopAlignment,
    buttonTopAlignment = _ref$buttonTopAlignme === void 0 ? false : _ref$buttonTopAlignme,
    _ref$buttonBottomLeft = _ref.buttonBottomLeftAlignment,
    buttonBottomLeftAlignment = _ref$buttonBottomLeft === void 0 ? false : _ref$buttonBottomLeft,
    _ref$buttonTopLeftAli = _ref.buttonTopLeftAlignment,
    buttonTopLeftAlignment = _ref$buttonTopLeftAli === void 0 ? false : _ref$buttonTopLeftAli,
    _ref$buttonTopRightAl = _ref.buttonTopRightAlignment,
    buttonTopRightAlignment = _ref$buttonTopRightAl === void 0 ? false : _ref$buttonTopRightAl,
    click = _ref.click,
    hoverVideoPlay = _ref.hoverVideoPlay,
    carouselEvent = _ref.carouselEvent,
    _ref$structuredScript = _ref.structuredScript,
    structuredScript = _ref$structuredScript === void 0 ? false : _ref$structuredScript,
    _ref$structuredScript2 = _ref.structuredScriptData,
    structuredScriptData = _ref$structuredScript2 === void 0 ? '' : _ref$structuredScript2,
    _ref$buttonCenterAlig = _ref.buttonCenterAlignment,
    buttonCenterAlignment = _ref$buttonCenterAlig === void 0 ? false : _ref$buttonCenterAlig,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
    _ref$muted = _ref.muted,
    muted = _ref$muted === void 0 ? false : _ref$muted,
    _ref$buttonFilled = _ref.buttonFilled,
    buttonFilled = _ref$buttonFilled === void 0 ? true : _ref$buttonFilled,
    _ref$videoFullHeight = _ref.videoFullHeight,
    videoFullHeight = _ref$videoFullHeight === void 0 ? false : _ref$videoFullHeight,
    _ref$isDetSite = _ref.isDetSite,
    isDetSite = _ref$isDetSite === void 0 ? false : _ref$isDetSite,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isInAnimatingHeader = _React$useState2[0],
    setIsInAnimatingHeader = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    playVideo = _React$useState4[0],
    setPlayVideo = _React$useState4[1];
  var _React$useState5 = React.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    paused = _React$useState6[0],
    setPaused = _React$useState6[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isButtonCenterOpacity = _useState2[0],
    setIsButtonCenterOpacity = _useState2[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isAnimating = _React$useState8[0],
    setIsAnimating = _React$useState8[1];
  var internalVideo = React.useRef();
  var topDiv = React.useRef();
  var iframePlayerRef = React.useRef();
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var playButtonLabel = getGlobalDictionaryTerm(sitecoreContext, 'atomVideoPlayBtn') || 'Play video';
  var breakpointValue = 992;
  var _React$useState9 = React.useState(breakpointValue),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    breakpoint = _React$useState0[0],
    setBreakpoint = _React$useState0[1];
  var isAnimationHeader = false;
  useVideoStructuredData(structuredScriptData);
  var isShown = playVideo || isInAnimatingHeader || hoverVideoPlay || autoplay;
  var youTubeVideoID = useMemo(function () {
    if (videoSrc) {
      var matchArr = videoSrc.match(/(?:https?:\/\/)?(?:www\.|m\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\/?\?v=|\/embed\/|\/)([^\s&?/#]+)/);
      return matchArr ? matchArr[1] : '';
    }
    return '';
  }, [videoSrc]);
  var _React$useState1 = React.useState("".concat(Math.random().toString(16).slice(2), "-youtube-player-").concat(youTubeVideoID)),
    _React$useState10 = _slicedToArray(_React$useState1, 1),
    ytPlayerId = _React$useState10[0];
  // const [player, setPlayer] = React.useState<any>(null);
  var player = React.useRef(null);
  var _useInView = useInView({
      triggerOnce: false
    }),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var updateVideoLocalStorage = function updateVideoLocalStorage(status) {
    var videosStorage = sessionStorage.getItem('videoStorage');
    if (videosStorage) {
      var prevStorage = JSON.parse(videosStorage);
      prevStorage.forEach(function (el) {
        if (el.id === "storage-".concat(videoSrc)) {
          el.isPlaying = status;
        } else {
          el.isPlaying = !status;
        }
      });
      sessionStorage.setItem('videoStorage', JSON.stringify(prevStorage));
      window.dispatchEvent(new Event('storage'));
    }
  };
  var checkVideoToLocalStorage = function checkVideoToLocalStorage() {
    var videoItemId = "storage-".concat(videoSrc);
    var videosStorage = sessionStorage.getItem('videoStorage');
    var videoItemArray = [];
    if (videosStorage) {
      videoItemArray = JSON.parse(videosStorage);
      // video pause
      videoItemArray.forEach(function (el) {
        if (el.id === videoItemId && !el.isPlaying) {
          if (videoType === 'external') {
            if (player.current && player.current.pauseVideo) {
              player.current.pauseVideo();
            }
          } else {
            if (internalVideo && internalVideo.current) {
              internalVideo.current.pause();
            }
            setPaused(true);
          }
        }
      });
    }
  };
  React.useEffect(function () {
    //set the list video to storage with false status
    var videoItem = {
      id: "storage-".concat(videoSrc),
      isPlaying: false
    };
    var videosStorage = sessionStorage.getItem('videoStorage');
    var videoItemArray = [];
    if (videosStorage) {
      var prevStorage = JSON.parse(videosStorage);
      var index = prevStorage.findIndex(function (item) {
        return item.id === "storage-".concat(videoSrc);
      });
      if (index === -1) {
        prevStorage.push(videoItem);
        videoItemArray = _toConsumableArray(prevStorage);
        sessionStorage.setItem('videoStorage', JSON.stringify(videoItemArray));
      }
    } else {
      videoItemArray.push(videoItem);
      sessionStorage.setItem('videoStorage', JSON.stringify(videoItemArray));
    }
  }, []);
  React.useEffect(function () {
    if (isShown && !inView) {
      if (videoType === 'external') {
        if (player.current && player.current.pauseVideo) {
          player.current.pauseVideo();
        }
      } else {
        if (internalVideo && internalVideo.current) {
          internalVideo.current.pause();
        }
        setPaused(true);
      }
    }
  }, [inView, isShown, videoType]);
  React.useEffect(function () {
    if (isShown && videoType === 'external') {
      if (player.current !== null) {
        if (player && player.current.playVideo) {
          player.current.playVideo();
          updateVideoLocalStorage(true);
        }
      }
    }
  }, [isShown, videoType]);
  var onPlayerStateChange = function onPlayerStateChange(event) {
    // 1  = playing state
    if (event.data === 1) {
      updateVideoLocalStorage(true);
    }
  };
  React.useEffect(function () {
    if (canUseDOM) {
      if (topDiv.current.closest('.header-animation-breakpoint')) {
        breakpointValue = parseInt(topDiv.current.closest('.header-animation-breakpoint').getAttribute('data-animation-breakpoint')) || breakpointValue;
        setBreakpoint(breakpointValue);
      }
      if (window.screen.width >= breakpointValue && (videoType === 'internal' || videoType === 'media')) {
        setIsInAnimatingHeader(topDiv.current.closest('.header-animation') ? true : false);
      }
    }
  }, []);
  React.useEffect(function () {
    if (typeof window !== 'undefined' && typeof document !== 'undefined' && videoType === 'external' && youTubeVideoID) {
      var playerNodeId = iframePlayerRef.current ? iframePlayerRef.current.id : '';
      var loadVideo = function loadVideo() {
        if (!player.current && window.YT.Player) {
          if (playerNodeId) {
            player.current = new window.YT.Player(playerNodeId, {
              videoId: youTubeVideoID,
              events: {
                onStateChange: onPlayerStateChange
              }
            });
          }
        }
      };
      if (window.YT && window.YT.loaded) {
        loadVideo();
      } else {
        window.onYouTubeIframeAPIReady = loadVideo;
      }
    }
  }, [youTubeVideoID, videoType]);
  React.useEffect(function () {
    window.addEventListener('storage', checkVideoToLocalStorage);
    return function () {
      window.removeEventListener('storage', checkVideoToLocalStorage);
    };
  }, []);
  React.useEffect(function () {
    if (canUseDOM) {
      if (internalVideo && internalVideo.current) {
        internalVideo.current.pause();
        setPaused(true);
      }
    }
  }, [carouselEvent]);
  var hoverEffect = function hoverEffect(play) {
    if (canUseDOM) {
      if (hoverVideoPlay) {
        if (internalVideo.current) {
          if (play) {
            internalVideo.current.play();
            updateVideoLocalStorage(true);
          } else {
            internalVideo.current.pause();
          }
        }
      }
    }
  };
  React.useEffect(function () {
    if (canUseDOM) {
      if (autoplay) {
        if (internalVideo.current) {
          internalVideo.current.play();
          document.querySelectorAll('.video-control-btn-hidden').forEach(function (btn) {
            btn.style.display = 'none';
          });
        }
      }
    }
  });
  var handlePlayClick = useCallback(function () {
    isAnimationHeader = false;
    if (canUseDOM) {
      if (window.screen.width >= breakpoint) {
        isAnimationHeader = topDiv.current.closest('.header-animation') ? true : false;
      }
    }
    if (isAnimationHeader) {
      if (videoType !== 'external' && internalVideo && internalVideo.current) {
        if (!isAnimating) {
          setIsAnimating(true);
          if (!paused) {
            setPaused(!paused);
            internalVideo.current.pause();
            topDiv.current.closest('.header-animation').classList.remove('header-video--appear');
            setTimeout(function () {
              topDiv.current.closest('.header-animation--play').classList.remove('header-animation--play');
            }, videoFadeTime);
            setTimeout(function () {
              setIsAnimating(false);
            }, videoFadeTime + videoWhiteOverlayTime);
          } else {
            topDiv.current.closest('.header-animation').classList.add('header-animation--play');
            setTimeout(function () {
              if (paused) {
                topDiv.current.closest('.header-animation').classList.add('header-video--appear');
                internalVideo.current.play();
                updateVideoLocalStorage(true);
                setPaused(!paused);
                setIsAnimating(false);
              }
            }, videoWhiteOverlayTime);
          }
        }
      } else {
        if (!isAnimating) {
          setIsAnimating(true);
          if (!paused) {
            topDiv.current.closest('.header-animation').classList.remove('header-video--appear');
            setTimeout(function () {
              topDiv.current.closest('.header-animation--play').classList.remove('header-animation--play');
            }, videoFadeTime);
            setTimeout(function () {
              setIsAnimating(false);
            }, videoFadeTime + videoWhiteOverlayTime);
          } else {
            topDiv.current.closest('.header-animation').classList.add('header-animation--play');
            setTimeout(function () {
              if (paused) {
                topDiv.current.closest('.header-animation').classList.add('header-video--appear');
              }
            }, videoWhiteOverlayTime);
          }
        }
        videoPlayPause();
      }
    } else {
      videoPlayPause();
    }
  }, [breakpoint, paused, setPlayVideo, setPaused, internalVideo, isAnimating]);
  var videoPlayPause = function videoPlayPause() {
    if (internalVideo && internalVideo.current) {
      if (paused) {
        internalVideo.current.play();
        updateVideoLocalStorage(true);
        // if(click) { click.bind('play') }
      } else {
        internalVideo.current.pause();
        // if(click) { click('pause') }
      }
    }
    setPaused(!paused);
    setPlayVideo(true);
  };
  var checkMouseMoved = throttle(function () {
    if (isButtonCenterOpacity && buttonCenterAlignment) {
      setIsButtonCenterOpacity(false);
    }
  }, 500);
  React.useEffect(function () {
    if (buttonCenterAlignment) {
      var timer;
      if (!isButtonCenterOpacity && !paused) {
        timer = setTimeout(function () {
          setIsButtonCenterOpacity(true);
        }, 1000);
      }
      return function () {
        clearTimeout(timer);
      };
    }
  }, [isButtonCenterOpacity, paused]);
  var renderVideo = function renderVideo() {
    return /*#__PURE__*/React.createElement("div", {
      ref: ref,
      style: {
        height: '100%'
      }
    }, videoType === 'external' ? /*#__PURE__*/React.createElement("div", {
      ref: iframePlayerRef,
      id: ytPlayerId,
      className: "youtube-video-iframe video-item"
    }) : /*#__PURE__*/React.createElement("video", _extends({
      className: clsx('video-atom', 'video-item', {
        'video-paused': paused
      }, _defineProperty({}, StyledVideoFitCover, videoFullHeight), _defineProperty({}, StyledVideo, !videoFullHeight)),
      ref: internalVideo,
      playsInline: true,
      autoPlay: hoverVideoPlay ? false : !isInAnimatingHeader,
      controls: true,
      loop: loop,
      onMouseEnter: function onMouseEnter() {
        return hoverEffect(true);
      },
      onMouseLeave: function onMouseLeave() {
        return hoverEffect(false);
      },
      onClick: function onClick() {
        setIsButtonCenterOpacity(paused);
        setPaused(!paused);
      },
      preload: "".concat(!isInAnimatingHeader ? 'auto' : 'none'),
      muted: muted
    }, otherProps), /*#__PURE__*/React.createElement("source", {
      src: videoSrc,
      type: "video/mp4"
    }), /*#__PURE__*/React.createElement("track", {
      kind: "captions"
    })));
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: topDiv,
    "data-testid": "you-tube-video",
    className: clsx(container, 'youtube-video-container', {
      'youtube-video-container--hover': hoverVideoPlay
    }, {
      'video-hidden': !isShown
    }, {
      'hidden-play-button': buttonCenterAlignment && isButtonCenterOpacity
    }),
    onMouseMove: checkMouseMoved
  }, renderVideo(), videoType === 'external' && !paused ? null : /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      if (click) {
        click(paused ? 'Play' : 'Paused');
      }
      handlePlayClick();
    },
    className: clsx('rs_skip', 'video-control-btn', 'my-icon-white', {
      'video-control-btn-hidden': autoplay
    }, _defineProperty({}, rtlButton, rtl), _defineProperty({}, ltrButton, !rtl), _defineProperty({}, topButton, buttonTopAlignment), _defineProperty({}, bottomButton, !buttonTopAlignment), _defineProperty({}, leftBottomButton, buttonBottomLeftAlignment), _defineProperty({}, leftTopButton, buttonTopLeftAlignment), _defineProperty({}, rightTopButtonRtl, buttonTopRightAlignment && rtl), _defineProperty({}, rightTopButtonLtr, buttonTopRightAlignment && !rtl), _defineProperty({}, centerButtonRtl, buttonCenterAlignment && rtl), _defineProperty({}, centerButtonLtr, buttonCenterAlignment && !rtl), _defineProperty({}, roundedButton, isDetSite)),
    "aria-label": "".concat(playButtonLabel, " button"),
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("span", {
    className: "accessibility-hidden-text"
  }, playButtonLabel), /*#__PURE__*/React.createElement("div", {
    className: "icon-play video-control-box rs_skip"
  }, isDetSite ? paused ? /*#__PURE__*/React.createElement(IconPlayDDA, null) : /*#__PURE__*/React.createElement(IconPauseDDA, null) : paused ? buttonFilled ? /*#__PURE__*/React.createElement(IconPlay2Item, null) : /*#__PURE__*/React.createElement(IconPlayItem, null) : /*#__PURE__*/React.createElement(IconPauseItem, null))));
};
var container = "c1ltgu9w";
var StyledVideo = "s131fr9h";
var StyledVideoFitCover = "s1sfttgl";
var ltrButton = "lxqb5mp";
var rtlButton = "rpnd126";
var topButton = "t1t42cp9";
var leftBottomButton = "l3rrbim";
var leftTopButton = "l1y68du6";
var rightTopButtonLtr = "r1exypts";
var rightTopButtonRtl = "r1k77vfo";
var bottomButton = "bz7l6hg";
var centerButtonLtr = "c1iytxdh";
var centerButtonRtl = "chae43a";
var roundedButton = "r19lcwc6";
export default Video;